export class UserPreferences {
  trialMessageShown: boolean

  constructor (data: any = {}) {
    Object.assign(this, data)
  }
}
